import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { isEmpty } from 'lodash';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ds-server-list',
  templateUrl: './server-list.component.html',
  styleUrls: ['./server-list.component.scss']
})
export class DsServersComponent implements OnInit {
  servers = environment.dsList;

  @Input()
  emitWhenSingle: boolean;
  @Output()
  serverSelected = new EventEmitter<KeyValue<string, string>>();

  ngOnInit(): void {
    if (!isEmpty(this.servers) && this.servers.size === 1 && this.emitWhenSingle) {
      const x = this.servers.entries().next().value;
      this.serverSelected.emit({ key: x[-1], value: x[1] });
    }
  }

  onServerSelected(event: MatSelectChange): void {
    this.serverSelected.emit(event.value);
  }
}
